import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const GpsAPI = {
	sessions: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/gpsSessions",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});
		return response.data;
	},
	list: async (matchId, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + matchId + "/gpsStats",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/gpsStats",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (matchId, gpsStatId, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/gpsStats/" + gpsStatId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (matchId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + matchId + "/gpsStats/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	playerList: async (playerId, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Players/" + playerId + "/gpsStats",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
};
